"use client";

import { InfoBox, Typography } from "@cappelendamm/design-system/react";
import { PiWarningCircle } from "react-icons/pi";
import { useFeidePurchaseGate } from "@/products/components/useFeidePurchaseGate";

export const FeideRequiredInfoBox = ({
  requiresFeideUser = false,
}: {
  requiresFeideUser?: boolean;
}) => {
  const { shouldShowFeideRequiredInfoBox } =
    useFeidePurchaseGate(requiresFeideUser);

  if (!shouldShowFeideRequiredInfoBox) return null;

  return (
    <InfoBox className="flex w-full items-start gap-2">
      <PiWarningCircle size={32} className="text-lg" />
      <Typography variant="body-sm">
        Dette produktet gir tilgang til et læremiddel som krever innlogging med
        Feide, og kan derfor ikke kjøpes som privatkunde.
      </Typography>
    </InfoBox>
  );
};
